module.exports = __webpack_public_path__ + "img/logo-min.892f637e.png";